import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {get} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: '',
}

export const fetchSubscriptionData = createAsyncThunk("fetchSubscriptionData", (params) => {
    return get(params);
});


const postSlice = createSlice({
    name: 'subscription',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchSubscriptionData.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchSubscriptionData.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''
        })
        builder.addCase(fetchSubscriptionData.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
    }
})


export default postSlice.reducer
